// extracted by mini-css-extract-plugin
module.exports = {"image":"product-only-pickup_image__GVXrI","imageContainer":"product-only-pickup_imageContainer__myaFh"};